// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useStatsigClient } from '@statsig/react-bindings';
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useApp } from '../helpers/api-helpers';
import { ReactComponent as CloseIcon } from '../icons/close.svg';
import { ReactComponent as HamburgerIcon } from '../icons/hamburger.svg';
import { ReactComponent as HomeIcon } from '../icons/home.svg';
import { ReactComponent as BillingIcon } from '../icons/profile-billing.svg';
import { ReactComponent as EnrollmentsIcon } from '../icons/profile-enrollments.svg';
import { ReactComponent as InfoIcon } from '../icons/profile-info.svg';
import { ReactComponent as ProfileToggleIcon } from '../icons/profile-mobile-toggle.svg';
import { ReactComponent as SignOutIcon } from '../icons/sign-out.svg';
import styles from './MobileAppHeader.module.css';
import NavLogo from './NavLogo';
import {
  missingUserInfoQuestions,
  NotificationIcon,
  ProfileMenu,
} from './ProfileMenu';
import { PurchaseCTA } from './PurchaseCTA';

function AppMenu() {
  const { user, tabs } = useApp();
  const [open, setOpen] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const { client } = useStatsigClient();

  const toggle = useCallback(() => {
    setOpen((open) => !open);
    setShowProfileMenu(false);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
    setShowProfileMenu(false);
  }, []);

  const location = useLocation();
  useEffect(() => {
    close();
  }, [location?.key]);

  const hasNotification = missingUserInfoQuestions(user);
  const newInfoPage = client.checkGate('new_info_page');

  const newInfoPageAndClerk = newInfoPage;

  return user ? (
    <div className={styles.navWrapper}>
      <div className={styles.navContent}>
        <button onClick={toggle}>
          {open ? <CloseIcon /> : <HamburgerIcon />}
        </button>
        {open && (
          <nav>
            {showProfileMenu ? (
              <ul>
                <li className={styles.open}>
                  <div onClick={() => setShowProfileMenu(false)}>
                    <HomeIcon />
                    <span>{user.firstName}</span>
                    <ProfileToggleIcon style={{ transform: 'rotate(90deg)' }} />
                  </div>
                </li>
                <li>
                  <NavLink to="/profile/enrollments">
                    <EnrollmentsIcon />
                    <span>Enrollments</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/profile/info">
                    <InfoIcon />
                    <span className={styles.profileLink}>
                      <span>Info</span>
                      {(newInfoPage || newInfoPageAndClerk) &&
                        hasNotification && <NotificationIcon />}
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/profile/billing">
                    <BillingIcon />
                    <span>Billing</span>
                  </NavLink>
                </li>
              </ul>
            ) : (
              <ul>
                {tabs?.map(({ path, title, icon }) => (
                  <li key={path}>
                    <NavLink to={path}>
                      {icon}
                      <span>{title}</span>
                    </NavLink>
                  </li>
                ))}
                <li>
                  <NavLink to="/logout">
                    <SignOutIcon />
                    <span>Sign Out</span>
                  </NavLink>
                </li>
              </ul>
            )}
          </nav>
        )}
      </div>
    </div>
  ) : null;
}

export function MobileAppHeader({ className }) {
  const { authState } = useApp();
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <>
      <header className={wrapperClassName}>
        <AppMenu />
        <NavLogo />
        {
          <div className="mr-2 flex">
            <ProfileMenu />
          </div>
        }
      </header>
      {authState === 'signIn' && <PurchaseCTA className={styles.purchaseCTA} />}
    </>
  );
}
